import React, { ReactElement, ReactNode } from "react";
import styled from "styled-components";
import { FieldProps } from "formik";

interface SelectBaseProps extends FieldProps {
  children: ReactNode;          // <option>...</option>
  placeholder?: string;         // если захочешь first option типа "Выберите..."
}

export const BaseSelect: React.FC<SelectBaseProps> = ({
  field,
  form,
  children,
  placeholder,
  ...rest
}): ReactElement => {
  const error = (form.errors as any)?.[field.name];
  const touched = (form.touched as any)?.[field.name];
  const hasError = Boolean(error && touched);

  return (
    <Wrapper>
      <StyledSelect
        {...field}
        {...rest}
        $hasError={hasError}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {children}
      </StyledSelect>
      {hasError && <ErrorText>{error}</ErrorText>}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin-bottom: 12px;
`;

const StyledSelect = styled.select<{ $hasError?: boolean }>`
  opacity: 0.5;
  width: 100%;
  height: 54px;
  background: none;
  border-radius: 16px;
  border: 1px solid ${({ $hasError }) => ($hasError ? "#ff4b4b" : "#E46DD6")};
  padding: 0 25px;
  font-family: "Manrope";
  font-size: 16px;
  color: rgba(254, 255, 255, 0.7);
  outline: none;

  &:focus {
    border-color: ${({ $hasError }) =>
      $hasError ? "#ff4b4b" : "#ff8be4"};
  }

  @media (min-width: 768px) {
    height: 64px;
    font-size: 22px;
  }

  option {
    color: #000;
    background: #fff;
  }
`;

const ErrorText = styled.div`
  margin-top: 4px;
  font-size: 12px;
  color: #ff4b4b;
`;
